import { get } from 'services/client';
import { apiEndpoints } from 'config';

const welcomeService = {
  getVisits: async () => {
    const options = { url: apiEndpoints.welcomeVisits };
    return get(options);
  },
  getWinesCount: async () => {
    const options = { url: apiEndpoints.welcomeWinesCount };
    return get(options);
  },
  getWineListsCount: async () => {
    const options = { url: apiEndpoints.welcomeWineListsCount };
    return get(options);
  },
};

export default welcomeService;
